// extracted by mini-css-extract-plugin
module.exports = {"containerSummary":"style_containerSummary__IYGxh","textBold":"style_textBold__EyrDk","textPastCars":"style_textPastCars__rWH4F"};